import { z } from 'zod'

import { Pagination } from 'app/types/app/request'
import { Product } from 'app/types/catalogue/product'

export const PriceLineStandard = Product.pick({
    purchase_price: true,
    price: true,
    price_badge: true,
    price_mobileapp: true,
}).extend({
    id: z.number().positive(),
    product: Product.pick({
        id: true,
        name: true,
        is_price_weight: true,
    }),
})

export type PriceLineStandard = z.infer<typeof PriceLineStandard>

const PriceLinesRequest = Pagination.extend({
    results: PriceLineStandard.array(),
})

export type PriceLinesRequest = z.infer<typeof PriceLinesRequest>

export const PriceLineCustomised = PriceLineStandard.omit({
    purchase_price: true,
}).extend({
    price: Product.shape.price.nullable(),
})

export const PriceLine = z.object({
    managerTable: PriceLineStandard,
    priceTable: PriceLineCustomised,
    product: PriceLineStandard.shape.product,
})

export type PriceLine = z.infer<typeof PriceLine>
